import type { BodyMapPickerEntry } from '@lmc/validations'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

type UseBodyMapPickerListProps = {
  enabled?: boolean
  residentId?: string
}

type BodyMapPickerListResponse = {
  data?: BodyMapPickerEntry[]
}

/**
 * The endpoint is unpaginated by design (see its controller), so there is no
 * cursor here. Exposes loading and error state, which useBodyMaps does not,
 * because the drawer shows a spinner and a failure message.
 */
const useBodyMapPickerList = ({
  enabled = true,
  residentId
}: UseBodyMapPickerListProps) => {
  const { data, error, isLoading } = useQuery(
    ['body-map-picker', residentId],
    () =>
      getJSON({
        url: `/v6/residents/${residentId}/body-maps/picker-list`
      }) as Promise<BodyMapPickerListResponse>,
    { enabled: enabled && !!residentId }
  )

  return {
    entries: data?.data ?? [],
    error,
    isLoading
  }
}

export default useBodyMapPickerList
